import { RestUrl } from "@/commons/constants/RestUrl";
import UrlFormatter from "@/commons/utils/UrlFormatter";
import CommonService from "@/commons/services/CommonService";
import LoginUser from "@/store/LoginUser";
import OtherUserGroupMessageModel from "@/commons/models/OtherUserGroupMessage";
import { HitomeqErrorType } from "@/commons/models/SystemError";

/**
 * 意見 API 操作クラス
 */
export default class OtherUserOpinions {
  /** 共通サービス */
  private commonService: CommonService;

  /**
   * ### コンストラクター
   *
   * - 共通サービスが渡されればそれを使用する
   * - 共通サービスが渡されなければ新しいインスタンスを作る
   *
   * @param commonService 共通サービス
   */
  constructor(commonService?: CommonService) {
    this.commonService = commonService ? commonService : new CommonService();
    return;
  }

  /**
   * GET OtherUserOpinions
   */
  public async gets(
    userStore: LoginUser,
    queryParams: {
      startIndex: number;
      endIndex: number;
      order: string;
    }
  ): Promise<Array<OtherUserGroupMessageModel>> {
    const formatParams: any = {
      facilityId: userStore.facility.id
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.OtherUserOpinions, formatParams);
    const response = await this.commonService.executeGet<Array<OtherUserGroupMessageModel>>(
      userStore,
      requestUrl,
      this.constructor.name,
      queryParams,
      HitomeqErrorType.REQUEST_RETRY,
      0
    );

    return response.data;
  }

  /**
   * GET OtherUserOpinionsCount
   */
  public async getCount(userStore: LoginUser, queryParams?: { confirmed: boolean }): Promise<number> {
    // countの場合は末尾に「count」をつける
    const formatParams: any = {
      facilityId: userStore.facility.id
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.OtherUserOpinions, formatParams);
    const params: any = queryParams ? queryParams : {};
    const response = await this.commonService.executeGet<{ count: number }>(userStore, `${requestUrl}/count`, this.constructor.name, params, HitomeqErrorType.REQUEST_RETRY, 0);

    return response.data.count;
  }
}
